import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import {
    MyRidesComponent,
    UserGeoContentItem,
} from '@polaris-customerweb/sharedcomponents.rides';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PlanRideButtonComponent } from 'src/app/components/shared/components/plan-ride-button/plan-ride-button.component';
import { RideTypeService } from 'src/app/services/ride-type.service';
import { AnalyticsService } from 'src/app/state/analytics/analytics.service';

@Component({
    imports: [AngularSvgIconModule, MyRidesComponent, PlanRideButtonComponent],
    selector: 'rdx-home-rides-list',
    standalone: true,
    styleUrls: ['./home-rides-list.component.scss'],
    templateUrl: './home-rides-list.component.html',
})
export class HomeRidesListComponent {
    @Output() importRide = new EventEmitter();

    initialRidesLoaded = false;
    ridesLength = 0;

    constructor(
        private analyticsService: AnalyticsService,
        private router: Router,
        private rideTypeService: RideTypeService
    ) {}

    navigateToRide(ride: UserGeoContentItem) {
        this.analyticsService.fireEvent(`ride selected`);
        this.navigateToUrl(ride.url);
    }

    navigateToUrl(url: string): void {
        this.analyticsService.fireEvent('start ride planning clicked');
        void this.router.navigateByUrl(url);
    }

    createPlanRide(rideType: 'ORV' | 'SNO' | '') {
        if (rideType === 'ORV') {
            this.rideTypeService.setRideType('ORV');
        } else if (rideType === 'SNO') {
            this.rideTypeService.setRideType('SNO');
        }
        this.analyticsService.fireEvent('create plan ride clicked');
        this.navigateToUrl('/map/planned-ride/create');
    }
}
